import React from "react"
import "bootstrap/dist/css/bootstrap.css"
import Icon from "components/elements/Icon"
import Col from "../../Col"
import { navigate } from "gatsby"

const Schedule = () => {
  const continueBtn = () => {
    navigate("/welcomevisit")
  }

  return (
    <div className="g-footer-schedule">
      <Col>
        <button  style={{padding: '0px'}} onClick={continueBtn} type="button">
          <span style={{fontSize: '22px', fontWeight: 'lighter'}}>Schedule an appointment</span>
          <Icon
            className="left"
            fill="transparent"
            fillSecondary="#ffffff"
            icon="Arrow"
            stroke="#ffffff"
            strokeWidth="3"
          />
        </button>
      </Col>
    </div>
  )
}

export default Schedule
